import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Coins, X, ArrowRight, Sparkles } from "lucide-react";

export default function InsufficientCreditsModal() {
  const [detail, setDetail] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => setDetail(e.detail || {});
    window.addEventListener("geneo:insufficient-credits", handler);
    return () => window.removeEventListener("geneo:insufficient-credits", handler);
  }, []);

  if (!detail) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0A0A0A]/80 backdrop-blur-sm p-6"
      data-testid="paywall-modal">
      <div className="relative max-w-md w-full p-8 rounded-3xl bg-gradient-to-br from-[#1a1208] via-[#120E15] to-[#0d1f24] border border-[#F2C94C]/40">
        <button
          onClick={() => setDetail(null)}
          data-testid="paywall-close"
          className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center text-white hover:text-white hover:bg-white/10 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="w-14 h-14 rounded-2xl bg-[#F2C94C]/20 border border-[#F2C94C]/40 flex items-center justify-center mb-4">
          <Coins className="w-7 h-7 text-[#F2C94C]" />
        </div>
        <h2 className="font-display text-3xl text-white mb-2">Out of credits</h2>
        <p className="font-body text-white mb-5">
          <span className="capitalize">{(detail.action || "This action").replace("-", " ")}</span> costs {" "}
          <span className="text-[#F2C94C] font-bold">{detail.cost} credits</span>{" "}
          — you have <span className="text-[#E27D60] font-bold">{detail.balance ?? 0}</span>. Top up or subscribe to keep creating.
        </p>
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            onClick={() => { setDetail(null); navigate("/pricing"); }}
            data-testid="paywall-upgrade-btn"
            className="flex-1 font-mono-hy text-xs px-5 py-3 rounded-full bg-[#F2C94C] text-[#0A0A0A] hover:bg-[#F2D06B] transition-all flex items-center justify-center gap-2"
          >
            <Sparkles className="w-3.5 h-3.5" /> See Pricing <ArrowRight className="w-3.5 h-3.5" />
          </button>
          <button
            onClick={() => setDetail(null)}
            data-testid="paywall-later-btn"
            className="font-mono-hy text-xs px-5 py-3 rounded-full border border-[#F2C94C]/25 text-white hover:text-white hover:border-[#F2C94C]/50 transition-all"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
